// import ReactGA from 'react-ga';
// import ReactGA4 from 'react-ga4';

//  Analytics tracking functions
// const googleAnalytics4Purchase = (totalCost, reference) => {
//   ReactGA4.event('purchase', {
//     debug_mode: true,
//     category: 'ecommerce',
//     transaction_id: reference,
//     currency: 'GBP',
//     affiliation: 'Raffle House',
//     value: totalCost,
//   });
// };
// const googleAnalytics4SubscriptionPurchase = (totalCost, reference) => {
//   ReactGA4.event('subscription', {
//     debug_mode: true,
//     category: 'ecommerce',
//     transaction_id: reference,
//     currency: 'GBP',
//     affiliation: 'Raffle House',
//     value: totalCost,
//   });
// };
// const googleAnalytics4BoughtTickets = (ticketsQuantity, reference) => {
//   ReactGA4.event('BoughtTickets', {
//     debug_mode: true,
//     category: 'ecommerce',
//     transaction_id: reference,
//     affiliation: 'Raffle House',
//     value: ticketsQuantity,
//   });
// };
// //  Analytics tracking functions
// const googleAnalyticsAddTransaction = (totalCost, reference) => {
//   ReactGA.plugin.execute('ecommerce', 'addTransaction', {
//     id: reference,
//     affiliation: 'Raffle House',
//     revenue: totalCost,
//   });
//   ReactGA4.event('addTransaction', {
//     debug_mode: true,
//     category: 'ecommerce',
//     id: reference,
//     affiliation: 'Raffle House',
//     revenue: totalCost,
//     value: totalCost,
//   });
// };

// const googleAnalyticsAddItem = (totalPrice, reference, ticketsQuantity) => {
//   const unitCost = parseInt((totalPrice / ticketsQuantity).toFixed());
//   ReactGA.plugin.execute('ecommerce', 'addItem', {
//     id: reference,
//     name: 'prize',
//     price: unitCost,
//     ticketsQuantity,
//     currency: 'GBP',
//   });
//   ReactGA4.event('addItem', {
//     debug_mode: true,
//     category: 'ecommerce',
//     id: reference,
//     name: 'prize',
//     price: unitCost,
//     quantity: ticketsQuantity,
//     currency: 'GBP',
//   });
// };

// const googleAnalyticsPurchase = (totalPrice, reference, ticketsQuantity) => {
//   googleAnalytics4Purchase(totalPrice, reference);
//   googleAnalytics4BoughtTickets(ticketsQuantity, reference);
//   ReactGA.plugin.require('ecommerce');
//   googleAnalyticsAddTransaction(totalPrice, reference);
//   googleAnalyticsAddItem(totalPrice, reference, ticketsQuantity);
//   ReactGA.plugin.execute('ecommerce', 'send');
// };

// const googleAnalyticsTrackEvent = (category = 'none', action = 'click', label = '') => {
//   ReactGA.event({
//     category,
//     action,
//     label,
//   });
//   ReactGA4.event({
//     category,
//     action,
//     label,
//   });
// };

// const googleAdwordsConversion = (transactionId = '', ticketsQuantity = 0) => {
//   /* eslint-disable */
//   if (process.env.NODE_ENV === 'production' && typeof gtag === 'function') {
//     gtag('event', 'conversion', {
//       send_to: process.env.GOOGLE_ADWORDS_TRACKING_ID,
//       transaction_id: transactionId,
//       currency: 'GBP',
//       // event_callback: null,
//       value: ticketsQuantity,
//     });
//   }
//   /* eslint-enable */
// };
// const somePixelPurchase = (transactionId = '', value = 0) => {
//   if (process.env.NODE_ENV === 'production' && typeof gtag === 'function') {
//     gtag('event', 'purchase', {
//       allow_custom_scripts: true,
//       value: value,
//       transaction_id: transactionId,
//       u2: value,
//       send_to: process.env.GOOGLE_ADWORDS_TRACKING_ID3,
//     });
//   }
// };

/**
 * Track events on Facebook Pixel
 * @param type: the event type, one of: "AddToCart", "Purchase", "Lead"
 * @param params: params sent along the tracking event. Vary according to the event type.
 */
// const facebookConversion = (type, params = {}, eventID = {}) => {
//   /* eslint-disable */
//   if (process.env.NODE_ENV === 'production' && typeof fbq === 'function' && params.value) {
//     fbq('track', type, params, eventID);
//   }
//   /* eslint-enable */
// };

// const facebookPageView = () => {
//   facebookConversion('PageView');
// };

// const facebookAddToCart = (order) => {
//   facebookConversion(
//     'AddToCart',
//     {
//       value: order.totalCost,
//       currency: 'GBP',
//       content_ids: [order.prizeId],
//       content_type: 'product',
//     },
//     { eventID: order._id }
//   );
// };

// const facebookPurchase = (value, orders, orderGroupId) => {
//   const prizeIds = orders.map((order) => {
//     return order._id;
//   });
//   facebookConversion(
//     'Purchase',
//     {
//       value: value,
//       currency: 'GBP',
//       content_ids: prizeIds,
//       content_type: 'product',
//     },
//     { eventID: orderGroupId }
//   );
// };
// const facebookSubscriptionPurchase = (value, prizeIds, orderGroupId) => {
//   facebookConversion(
//     'Purchase',
//     {
//       value: value,
//       currency: 'GBP',
//       content_ids: prizeIds,
//       content_type: 'product',
//     },
//     { eventID: orderGroupId }
//   );
// };
// const facebookViewContent = () => {
//   facebookConversion('ViewContent', {}, {});
// };
// const facebookInitiateCheckout = (ids, value) => {
//   facebookConversion('InitiateCheckout', { value: value, content_ids: ids }, {});
// };

// const facebookLead = () => {
//   facebookConversion('Lead');
// };

// const ttdPixelApi = (orderId, revenue) => {
//   ttd_dom_ready(function () {
//     if (typeof TTDUniversalPixelApi === 'function') {
//       var universalPixelApi = new TTDUniversalPixelApi();
//       universalPixelApi.init('0biuhr1', ['2voh705'], 'https://insight.adsrvr.org/track/up', {
//         orderid: orderId,
//         v: revenue,
//       });
//     }
//   });
// };
const tiktokConversionTrack = (orderId, revenue, currency) => {
  // <!-- TIKTOK CONVERSION -->
  if (process.env.NODE_ENV === 'production' && window.ttq !== undefined && typeof window.ttq.track === 'function') {
    console.log('Start track tiktok purchase');
    window.ttq.track('PlaceAnOrder', {
      value: revenue, // number. Value of the order or items sold. Example: 100.
      currency: currency || 'GBP', // string. The 4217 currency code. Example: "USD".
      contents: [
        {
          content_id: orderId, // string. ID of the product. Example: "1077218".
          content_type: 'TICKET', // string. Either product or product_group.
          content_name: '<content_name>', // string. The name of the page or product. Example: "shirt".
        },
      ],
    });
    console.log('End track tiktok purchase');
  }
  // <!-- END OF TIKTOK CONVERSION -->
};

// const snapchatPurchaseTrack = () => {
//   if (process.env.NODE_ENV === 'production' && typeof snaptr === 'function') {
//     console.log('Start track snapchat purchase');
//     snaptr('track', 'PURCHASE');
//     console.log('End track snapchat purchase');
//   }
// };

// Twitter tracking
const twitterTrack = (eventId, payload) => {
  if (
    window.twq !== undefined &&
    typeof window.twq === 'function'
    // && process.env.NODE_ENV === 'production'
  ) {
    window.twq('event', eventId, payload);
  }
};
const twitterPageViewTrack = (pathname) => {
  console.log('Twitter Page View tracking event', process.env.REACT_APP_TWITTER_PIXEL_PAGE_VIEW_ID, pathname);
  twitterTrack(process.env.REACT_APP_TWITTER_PIXEL_PAGE_VIEW_ID, { pathname: pathname });
};

export default {
  // googleAnalytics4Purchase,
  // googleAnalyticsPurchase,
  // googleAdwordsConversion,
  // facebookPageView,
  // facebookViewContent,
  // facebookAddToCart,
  // facebookPurchase,
  // facebookInitiateCheckout,
  // facebookLead,
  // googleAnalyticsTrackEvent,
  // googleAnalytics4BoughtTickets,
  // facebookSubscriptionPurchase,
  // googleAnalytics4SubscriptionPurchase,
  // somePixelPurchase,
  // ttdPixelApi,
  tiktokConversionTrack,
  // snapchatPurchaseTrack,
  twitterPageViewTrack,
};
